export default __webpack_public_path__ + "static/media/image.rocketeer-labs.bf66cf42.png";